<template>
  <div>
    <div v-if="showMode" class="tdfxhzClass djfxDialog onePictureDialog dy3dDialog" id="analysisStep_2">
      <!-- 展开收起图标 -->
      <img class="sideIconBox" :src='require("@/assets/images/sideIconLeft.png")' @click="sideShow()" />
      <div class="headerClass">
        <div class="headerTitle">
          <span>{{dialogTitle}}</span>
        </div>
        <div class="boxClose">
          <img :src="require('@assets/images/poscloseIcon.png')" style="cursor: pointer;" @click="close()" />
        </div>
      </div>
      <div class="content">
        <img class="splitLine" :src="require('@/assets/images/splitlineIcon.png')"/>
        <!-- 选择图层 -->
        <div class="selectTc">
          <a-col :span="4" style="font-size:16px">选择图层：</a-col>
          <a-col :span="12" class="tcComponent">
            <selectTc-component ref="selectTcComponent" :map="map" :title="myTitle" :selectLayerBsm='selectLayerBsm' :projectList="projectList" @getLayerData="getLayerData"></selectTc-component>
          </a-col> 
        </div>
        <!-- 选择算法 -->
        <div class="selectKjsf">
          <a-col :span="6" style="font-size:16px">选择空间算法：</a-col>
          <a-col :span="18" class="tcComponent">
            <a-radio-group v-model="methodsQuery" name="radioGroup" :default-value="1">
                <a-radio :value="1">
                相交
                </a-radio>
                <a-radio :value="2">
                相切
                </a-radio>
            </a-radio-group>  
          </a-col>     
        </div>
        <!-- 分析范围 -->
        <div class="fwToolClass">
            <selectFw-component 
              ref="selectFwComponent" 
              :dialogTitle='dialogTitle' 
              :map="map" 
              :fwData='fwData' 
              :selectLayerBsm='selectLayerBsm' 
              :buttonLoading="tjLoading" 
              :myCollectionTreeData='myCollectionTreeData'  
              @setTableHeight='setTableHeight'
              @deleteFw='deleteFw' 
              @getFwdata="getFwdata" 
              @goSingalStatic="goSingalStatic" 
              @analysisSaveFw='analysisSaveFw'></selectFw-component>
        </div>
        <!-- 配置分析规则  专题分析没有 -->
        <div class="editInfo" v-if="dialogTitle != '专题分析'">
          <span>配置分析规则</span>
          <img :src="require('@/assets/images/staticIcon.png')" style="cursor: pointer;" title='编辑分析规则' v-if="statisticsConfigTableData.length > 0" @click="setStaticInfo('编辑')"/>
        </div>
        <div class="staticInfo" v-if="dialogTitle != '专题分析'">
          <a-button v-if="!statisticsConfigTableData.length > 0" class="primaryBtn" @click="setStaticInfo('新增')">配置分析规则</a-button>
          <div v-if="statisticsConfigTableData.length > 0" class="tableInfo">
            <a-table
                class="tableHeaderClass"
                ref="table"
                bordered
                size="middle"
                :rowKey="(record,index)=>{return index}"
                :scroll="{x:470,y:tbodyHeight}"
                :columns="columns"
                :data-source="statisticsConfigTableData"
                :pagination="false"
                >
            </a-table>            
          </div>
        </div>

        <a-button class="statisticsBtn" :disabled="(dialogTitle != '专题分析' && statisticsConfigTableData.length === 0)" @click="goStatic" :loading='tjLoading'>分析</a-button>
      </div>
    </div>
    <!-- 配置统计信息的弹框 -->
    <staticInfo-component ref="staticInfoComponent" @getStaticData="getStaticData"></staticInfo-component>
    <!-- 统计信息表格 -->
    <summary-information ref="summaryInformation" 
      :selectLayerBsm='selectLayerBsm' 
      :projectBsm='projectBsm' 
      :ztName='projectName' 
      :dialogTitle='dialogTitle' 
      :layerLists='layerLists' 
      :myCollectionTreeData='myCollectionTreeData' 
      @miniSizeMethod="miniSizeMethod" 
      @closeMiniSizeDialog='rebackShow' 
      @analysisCheckDetail='analysisCheckDetail' 
      @checkLayerAttrs='checkLayerAttrs'
      @analysisExport='analysisExport'
      @analysisCollect='analysisCollect'
      @closeLayerManageDialog='closeLayerManageDialog'></summary-information>
    <!-- 统计信息最小化弹框 -->
    <minimize-dialog ref="minimizeDialog" @reback="rebackShow"></minimize-dialog>
    <img v-show="sideVisible" class="sideshowClass" :src='require("@/assets/images/sideIconRight.png")' @click="sideShow()" />
  </div>
</template>
  
  <script>
  import { guide } from '../../../../utils/beginnerGuide'
  // import Vue from 'vue'
  import 'proj4leaflet'
  import WKT from "terraformer-wkt-parser" //WKT可换为wkt
  // import { postHeadersAction_ds} from '../../../../api/manage'
  import selectFwComponent from './selectFwComponent.vue'
  import selectTcComponent from './selectTcComponent.vue'
  import staticInfoComponent from './setStaticInfoDialog.vue'
  import summaryInformation from './summaryInformation.vue'
  import minimizeDialog from '../../../components/minimizeDialog.vue'
  import dy3dMap from '../../../js/dy3dMap.js'
  const DYMAP = new dy3dMap()
  // 我是分析组件
  export default {
    name: 'djfxDialog',
    components: {
        selectFwComponent,
        selectTcComponent,
        staticInfoComponent,
        summaryInformation,
        minimizeDialog
    },
    data() {
      return {
        pageKey:'', // 页面对应的key  'djfx'-叠加分析  'hcfx'-缓冲分析  专题bsm-专题分析
        geoserverUrl:'',
        // 判断是什么操作：新增、编辑、查看 统计信息配置
        setStaticInfoAction:'', 
        sideVisible:false,
        // 弹框的标题
        dialogTitle:'',
        projectName:'',
        projectBsm:'',
        tjLoading:false, // 统计按钮保护
        showMode: false,
        hideMode: false,
        graphicLayer:null,
        myTitle:'土地汇总分析',
        map: null,
        layerData:null,  // 选中的图层数据
        queryParam:{
            qyjg:'0',
            zylx:'0',
        },
        // 勾选的图斑数据
        layerParams:[],
        fwArry:[],
        // condition测试数据
        condition:[],
        // 统计配置信息表格数据
        statisticsConfigTableData:[],
        // 统计或者分析出来的数据
        statisticsResults:null,
        // 组装详情接口的gemos入参值 
        geoms:null,
        selectLayerBsm:'',  //选择的图层bsm
        columns: [
          {
            title: "字段",
            dataIndex: "mc",
            align:'center',
            with:100,
          },
          {
            title: '别名',
            align: "center",
            with:150,
            dataIndex: 'alias',
          },
          {
            title: '查询排序',
            align: "center",
            dataIndex: 'order',
            with:50,
            customRender: (text, record) => {
                return text == '0' ? '无' : text == '1' ? '升序' : '降序'
            }
          },
          {
            title: '统计',
            align: "center",
            dataIndex: 'istj',
            with:50,
            customRender: (text, record) => {
                return text == false ? '否' : '是'
            }
          },
          {
            title: '分类',
            align: "center",
            dataIndex: 'isfl',
            with:50,
            customRender: (text, record) => {
                return text == false ? '否' : '是'
            }
          },
          {
            title: '排序',
            align: "center",
            // with:60,
            dataIndex: 'xh',
          }
        ],
        hturl:{
          // 根据配置条件统计分析图层数据(用于叠加分析和缓冲分析)
          getAnalyse:'/hzfx/analyse',
          // 根据配置条件统计分析图层数据（用于专题分析）
          getZtfxAnalyse:'/hzfx/ztfxAnalyse'
        },
        projectList:[],
        layerLists:[], // 选择图层的下拉框数据（平级的 图层数据）
        tableHeight:200,
        methodsQuery:1, //选择的算法
        myCollectionTreeData:[],
        tbodyHeight: 198,
      }
    },
    props:{
      
      // 图斑范围的表格数据111
      fwData:{ 
        type:Array,
        default:() => []
      },
      /** 
       * @param 点击统计调用的接口
       * 接口必须是post请求，返回的格式是{code:0, data:[]}
       */
      analysisUrl: {
        type: String,
        default: '/hzfx/analyse'
      },
    },
    mounted () {
      // this.$bus.$on('closeDjfxDialog',() => {
      //   this.close()
      //   this.$bus.$off('closeDjfxDialog')
      // });
      /**
       * @param {array} statisticsResults  每个图斑对应的分析结果信息如下：
       * @param {string} bsm 图斑bsm
       * @param {array} data 统计信息的表格数据
       * @param {*} dataInfoSize 
       * @param {string} name  图斑名称 
       * @param {string} dialogTitle  弹框名称-'叠加分析' '缓冲分析' '专题分析'
       * 
       * @param {array} conditionVOList  统计信息配置的表格数据
       */
      this.$bus.$on('completeAnalysis',(statisticsResults,conditionVOList) => {
        // this.statisticsResults = this.dialogTitle == '专题分析' ? res.data.geomList : res.data
        this.statisticsConfigTableData = statisticsResults[0].dialogTitle == '专题分析' ? conditionVOList : this.statisticsConfigTableData
        console.log('分析完成的回调',statisticsResults,this.statisticsConfigTableData);
        this.statisticsResults = statisticsResults
        let info = {
          msg: this.statisticsConfigTableData,
          fwArry: this.fwArry,
          resData: statisticsResults,
          layerParams: this.geoms,
          map: this.map,
          methods: this.methodsQuery,
          layerData: this.layerData,
          pageKey: this.pageKey,
          geoserverUrl:this.geoserverUrl
        }
        this.$refs.summaryInformation.setMap(info)
        this.sideShow()
        this.tjLoading = false
      });
    },
    beforeDestroy () {
      console.log('beforeDestroy beforeDestroy beforeDestroy 222');
      this.$bus.$off('completeAnalysis');
    },
    methods: {
      /** 
       * 初始化弹框
       * @param {array} info.treeData  选择图层的下拉框数据——[{ dataName:'', children:[], disabled:false }]
       * @param {array} info.myCollectionTreeData  我的收藏的树结构数据
       * @param {string} info.dialogTitle  弹框的标题
       * @param {string} info.projectName  如果是专题分析，选择的专题名称（作为统计接口的入参）
       * @param {string} info.projectBsm  如果是专题分析，选择的专题bsm（保存分析结果的时候要用）
       * @param {string} info.action  如果是从我的收藏跳转过来的，值是‘查看’，否则没有值
       * @param {string} info.pageKey  页面对应的key  'djfx'-叠加分析  'hcfx'-缓冲分析  专题bsm-专题分析
       * @param {string} info.geoserverUrl  geoserver服务对应的配置地址
       */
      setMap(info) {
        let {map, treeData, myCollectionTreeData, dialogTitle, projectName, projectBsm, action} = info
        console.log('打开分析弹框',treeData,dialogTitle,projectName,projectBsm,action);
        this.map = map
        this.pageKey = info.pageKey
        this.geoserverUrl = info.geoserverUrl
        this.myCollectionTreeData = myCollectionTreeData
        this.setStaticInfoAction = action
        this.dialogTitle = dialogTitle
        this.projectName = projectName
        this.projectBsm = projectBsm
        this.projectList = JSON.parse(JSON.stringify(treeData)) 
        this.loopNode(this.projectList)
        if(dialogTitle == '专题分析'){
          this.projectList.unshift({bsm:'00',dataName:'综合'})
        }
        console.log('this.projectList',this.projectList,this.fwData);        
        this.showMode = true
        this.sideVisible = false
        // 清空地图上的数据
        let obj = {
          map:this.map,
          attr:'name',
          attrValue:'查询结果'
        }
        DYMAP.removeLayerByAttr(obj)
        // let geoLayer = this.map.getLayerByAttr('查询结果','name')
        // if(geoLayer){
        //   this.map.removeLayer(geoLayer)
        // }
        this.$nextTick(()=>{
          this.$refs.selectFwComponent.showBuffer = dialogTitle == '缓冲分析' ? true : false
          if(this.fwData){
            let selectFwComponent = this.$refs.selectFwComponent
            selectFwComponent.oprateInfoArry = this.fwData
            this.fwData.forEach(item=>{
              selectFwComponent.initGeoJsonLayer(item,this.map)
            })
            this.selectArea(this.projectList)
          }
          this.setTableHeight()
          // if(Vue.ls.get('Intro_yztfx_status') !== 'false'){
          //   guide('一张图-分析','一张图-分析','Intro_yztfx_status')
          // }
        })    
      },
      // 设置配置统计信息表格的高度
      setTableHeight(){
        this.$nextTick(() => {
          let parentElement = document.querySelector('.djfxDialog > .content');
          if(parentElement){
            // 获取其他元素的高度总和
            var otherElementsHeight = 0;
            var otherElements = document.querySelectorAll('.djfxDialog > .content > *'); // 获取所有直接子元素
            otherElements.forEach(element => {
              if(!Array.from(element.classList).includes('staticInfo')){
                otherElementsHeight += this.getEleTotalHeight(element); // 考虑元素的高度，包括内外边距
              }
            });
    
            // 计算目标元素的高度
            var targetElementHeight = this.getEleTotalHeight(parentElement) - otherElementsHeight;
            let theadHeight = document.querySelector('.staticInfo .ant-table-header') ? this.getEleTotalHeight(document.querySelector('.staticInfo .ant-table-header')) : 0
            this.tbodyHeight = targetElementHeight - theadHeight - 60
            // // 设置目标元素的高度
            // var targetElement = document.getElementById('target-element');
            // targetElement.style.height = targetElementHeight + 'px';
          }
        })
      },
      // 获取元素高度（包括内外边距、边框高度）
      getEleTotalHeight(targetElement){
        // 获取元素的实际高度，包括内边距和边框
        let elementHeight = targetElement.clientHeight;
        // 获取元素的计算样式
        let computedStyle = window.getComputedStyle(targetElement);
        // 获取元素的上外边距和下外边距
        let marginTop = parseInt(computedStyle.marginTop);
        let marginBottom = parseInt(computedStyle.marginBottom);
        // 计算元素的高度，包括外边距
        return elementHeight + marginTop + marginBottom;
      },
      // 删除选择范围后的处理
      deleteFw(){
        let geoLayer = this.map.getLayerByAttr('查询结果','name')
        if(geoLayer){
          this.map.removeLayer(geoLayer)
        }
        if(this.$refs.summaryInformation){
          this.$refs.summaryInformation.close()  // 关闭统计信息弹框
        }
        if(this.$refs.staticInfoComponent){
          this.$refs.staticInfoComponent.close()  // 关闭统计配置信息弹框
        }
        if(this.$refs.minimizeDialog){
          this.$refs.minimizeDialog.close()  // 关闭最小化弹框
        }
      },
      // 关闭弹框
      close() {
        this.showMode = false
        this.sideVisible = false
        this.layerData = null
        this.layerParams = []  // 清除勾选的手绘数据
        this.layerLists = []  // 清除选中的图层的下拉框数据（平级的 图层数据）
        this.statisticsConfigTableData = []  // 清除统计配置信息表格数据
        this.statisticsResults = null  // 清除统计配置信息表格数据
        this.geoms = null  // 清除组装详情接口的gemos入参值 
        this.selectLayerBsm = ''  // 清除选中的图层bsm
        // 清除绘制的图形
        if(this.map){
          this.map.graphicLayer.clear()
          // 清除汇总分析里选择和手绘的图斑数据
          this.map.getLayers().map(layer => {
            if(layer.options.name == '手绘图层'){
              this.map.removeLayer(layer)
            }else if(layer.options.name == '查询分析图层'){
              this.map.removeLayer(layer)
            }else if(layer.options.name == '缓冲分析图层'){
              this.map.removeLayer(layer)
            }
          })
          // 清空地图上的数据
          let obj = {
            map:this.map,
            attr:'name',
            attrValue:'查询结果'
          }
          DYMAP.removeLayerByAttr(obj)
        }
        if(this.$refs.selectFwComponent){
          this.$refs.selectFwComponent.oprateInfoArry = []  // 关闭选择分析范围的弹框
          this.$refs.selectFwComponent.bdcRowKeys = []  // 清空手绘表格勾选的数据
          this.$refs.selectFwComponent.cssArr = []  // 清空手绘表格勾选的数据
        }
        if(this.$refs.summaryInformation){
          this.$refs.summaryInformation.close()  // 关闭统计信息弹框
        }
        if(this.$refs.staticInfoComponent){
          this.$refs.staticInfoComponent.close()  // 关闭统计配置信息弹框
        }
        if(this.$refs.minimizeDialog){
          this.$refs.minimizeDialog.close()  // 关闭最小化弹框
        }
      },
      // 显示 或 隐藏弹框
      sideShow() {
        this.showMode = !this.showMode
        this.sideVisible = !this.sideVisible
        if(this.showMode){
          this.$nextTick(() => {
            this.$refs.selectFwComponent.bdcRowKeys = this.geoms ? this.geoms.map(item => item.bsm) : []
          })
        }
      },
      // 处理节点，为了渲染
      loopNode(data){
        data.map(item => {
          if(this.dialogTitle == '专题分析'){
            item.dataName = item.title
            item.children = item.childLayers
          }
          if(!item.children || item.children.length === 0){
            // 没有children的说明是图层节点
            this.layerLists.push(item)
          }
          if(item.children && item.children.length > 0){
            // 有子节点的禁止点击
            item.disabled = true
            this.loopNode(item.children)
          }
        })
      },
      selectArea(list){
        list.forEach(item=>{
          if(item.children){
            this.selectArea(item.children)
          }else{
            if(item.bsm === this.selectLayerBsm){
              this.layerData = item
              // 得初始化一下图层，否则直接点统计的时候图上无法高亮
              this.queryMapserver = new mars3d.query.QueryGeoServer({
                // url: "http://192.168.1.16:9090/geoserver/wfs",
                url: this.geoserverUrl + "/wfs",
                layer: this.layerData.alias
              })
            }
          }
        })
      },
      // 重新加载图层方法
      reLoadGraphic(){
        if(this.graphicLayer){
          this.graphicLayer.remove()
          this.graphicLayer = null
        }
        // 创建矢量数据图层
        this.graphicLayer = new mars3d.layer.GraphicLayer()
        this.map.addLayer(this.graphicLayer)
      },
      // 高亮区域方法
      addDemoGraphic1(graphicLayer,positions) {
        const graphic = new mars3d.graphic.PolygonEntity({
          positions: positions,
          style: {
            color: "#3388ff",
            opacity: 0.3,
            outline: true,
            outlineWidth: 3,
            outlineColor: "#ffffff",
            label: {
              text: "",
              font_size: 18,
              color: "#ffffff",
              distanceDisplayCondition: true,
              distanceDisplayCondition_far: 500000,
              distanceDisplayCondition_near: 0
            }
          },
          attr: { remark: "示例1" }
        })
        graphicLayer.addGraphic(graphic)
      },
      // 获取图层数据信息
      getLayerData(node){
        this.layerData = node
        this.selectLayerBsm = node.bsm
        this.statisticsConfigTableData = []  // 清除统计配置信息表格数据
        // 得初始化一下图层，否则直接点统计的时候图上无法高亮
        this.queryMapserver = new mars3d.query.QueryGeoServer({
          // url: "http://192.168.1.16:9090/geoserver/wfs",
          url: this.geoserverUrl + "/wfs",
          layer: this.layerData.alias
        })
      },
      // 配置统计信息弹框
      setStaticInfo(action){
        this.setStaticInfoAction = this.setStaticInfoAction == '查看' ? this.setStaticInfoAction : action
        if(this.layerData){
          this.$refs.staticInfoComponent.setMap(this.layerData.attributes,this.setStaticInfoAction,this.statisticsConfigTableData)
        }else{
          this.$message.warning('请先选择图层再操作！')
        }
      },
      // 点弹框底部的统计按钮
      goStatic(){
        console.log('统计',this.layerData,this.layerLists,this.layerParams);
        if(this.layerParams.length === 0){
          this.$message.warning('请先勾选要分析的图斑范围！')
          return
        }
        if(this.statisticsConfigTableData.length === 0 && this.dialogTitle != '专题分析'){
          this.$message.warning('请先编辑分析规则!')
          return
        }
        this.tjLoading = true
        this.geoms = this.layerParams
        this.startStatistics()
      },
      /**
       * 点表格行的分析按钮
       * @param {array} layers 要分析的图斑数据,每个图斑包含的信息如下：
       * @param {string} bsm  图斑bsm
       * @param {string} dkmj 图斑面积
       * @param {string} name 图斑名称
       * @param {array} pointArry 图斑范围坐标
       * @param {object} style 图斑样式
       * @param {object} tcLayer  渲染图斑的数据 {geometry:{}, properties:{}, type:'Feature'}
       */
      goSingalStatic(layers){
        if(this.statisticsConfigTableData.length === 0 && this.dialogTitle != '专题分析'){
          this.$message.warning('请先编辑分析规则!')
          return
        }
        this.tjLoading = true
        var msgArry = []
        this.fwArry = layers
        for(var item of layers){
          if(!item.analysisType){
            item.tcLayer.geometry.coordinates[0].push(item.tcLayer.geometry.coordinates[0][0])
          }          
          let obj = {}
          obj.bsm = item.bsm
          obj.name = item.name
          obj.geom = item.analysisType ? WKT.convert(item.bufferLayer.tcLayer.geometry): WKT.convert(item.tcLayer.geometry)  
          msgArry.push(obj)
        }
        this.geoms = msgArry
        this.startStatistics()
      },
      // 统计调接口
      startStatistics(){
        // 清空地图上的数据
        let obj = {
          map:this.map,
          attr:'name',
          attrValue:'查询结果'
        }
        DYMAP.removeLayerByAttr(obj)
        // let geoLayer = this.map.getLayerByAttr('查询结果','name')
        // if(geoLayer){
        //   this.map.removeLayer(geoLayer)
        // }
        // 关闭分析弹框
        this.$refs.summaryInformation && this.$refs.summaryInformation.close()
        // 关闭最小化弹框
        this.$refs.minimizeDialog && this.$refs.minimizeDialog.close()
        let params = {
          geoms:this.geoms,
          algorithm:this.methodsQuery
        }
        if(this.dialogTitle == '专题分析'){
          let tcmcList= []
          if(this.layerData.dataName != '综合'){
            tcmcList = [this.layerData.alias.split(":")[1]]
          }else{
            this.layerLists.map(item => {
              if(item.dataName != '综合'){
                tcmcList.push(item.alias.split(":")[1])
              }
            })
          }
          params.ztName = this.projectName
          params.tcmcList = tcmcList
        }else{
          // 叠加分析、缓冲分析
          params.conditionVOList = this.statisticsConfigTableData
          // params.tcmc = this.layerData.title.split(":")[1]
          params.tcmc = this.layerData.alias.split(":")[1]
        }
        this.$emit('analysis',params, this.dialogTitle)
        this.showGeometry()
      },
      // 获取需要统计的图斑范围数据
      getFwdata(msg){
        this.layerParams = []
        this.fwArry = msg
        for(var item of msg){
          item.tcLayer.geometry.coordinates[0].push(item.tcLayer.geometry.coordinates[0][0])
          let obj = {}
          obj.bsm = item.bsm
          obj.name = item.name
          obj.geom = WKT.convert(item.tcLayer.geometry)  
          this.layerParams.push(obj)
        }
        this.setTableHeight()
      },
      // 获取需要统计的数据
      getStaticData(msg){
        this.statisticsConfigTableData = msg
        this.statisticsConfigTableData.sort((a,b)=> a.xh - b.xh)
        this.setTableHeight()
      },
      // 实现最小化方法
      miniSizeMethod(msg){
        this.$refs.minimizeDialog.setMap(msg)
      },
      // 恢复弹框显示
      rebackShow(){
        this.$refs.minimizeDialog && this.$refs.minimizeDialog.close()
        let info = {
          msg: this.statisticsConfigTableData,
          fwArry: this.fwArry,
          resData: this.statisticsResults,
          layerParams: this.geoms,
          map: this.map,
          methods: this.methodsQuery,
          layerData: this.layerData,
          pageKey: this.pageKey
        }
        this.$refs.summaryInformation.setMap(info)
        this.showGeometry()
      },
      showGeometry(){
        let aliveLayer = this.map.getLayerByAttr('查询分析图层','name')
        if(aliveLayer){
          this.map.removeLayer(aliveLayer)
        }
        let pointsArr = []
        this.fwArry.forEach(fw=>{
          let obj = {
            positions: fw.analysisType ? fw.bufferLayer.pointArry : fw.pointArry,
            style: fw.analysisType ? fw.bufferLayer.style : fw.style
          }
          pointsArr.push(obj.positions)
        })

        for (let index = 0; index < this.fwArry.length; index++) {
          let graphic = new mars3d.graphic.PolygonEntity({
              positions: this.fwArry[index].analysisType ? this.fwArry[index].bufferLayer.pointArry : this.fwArry[index].pointArry,
              style: this.fwArry[index].analysisType ? this.fwArry[index].bufferLayer.style : this.fwArry[index].style,
          })
          let queryLayer = new mars3d.layer.GeoJsonLayer({
              id:this.fwArry[index].bsm,
              name: '查询分析图层',
              symbol: {
                  type: "polygonP",
                  styleOptions: {
                      color: "#00ffff", // 填充颜色
                      opacity:0.3,
                      outline:true,
                      outlineWidth:1,
                      outlineColor:'#00ffff',
                      clampToGround: true
                  },
              }
          })
          this.map.addLayer(queryLayer)

          DYMAP.queryAnalaysis(this.geoserverUrl + "/wfs",this.layerData.alias,null,{graphic:graphic,geometryName:'geom'},null)

          this.queryMapserver.query({
            column: "",
            text: '',
            graphic: graphic,
            geometryName:'geom',
            page: false,
            maxFeatures:1000,
            success: (result) => {
              if (result.count === 0) {
                return
              }
              console.log('result11',result);
              if(this.methodsQuery == 2){
                const drawGeoJSON = graphic.toGeoJSON({ outline: true })
                const arrFeatures = result.geojson.features
                for (let i = 0; i < arrFeatures.length; i++) {
                  const feature = arrFeatures[i]
                  try {
                    const geojsonNew = turf.intersect(drawGeoJSON, feature) // 切割
                    if (geojsonNew) {
                        feature.geometry = geojsonNew.geometry
                    }
                  } catch (e) {
                    this.$message.error("切割异常，请重新切割");
                  }
                }
              }
              queryLayer.load({ data: result.geojson })
            },
            error: (error, msg) => {
              console.log("服务访问错误", error)
            }
          })  
        }
      },
      analysisSaveFw(msg){
        this.$emit('analysisSaveFw',msg)
      },
      analysisCheckDetail(action,msg,title){
        this.$emit('analysisCheckDetail',action,msg,title)
      },
      checkLayerAttrs(msg){
        this.$emit('checkLayerAttrs',msg)
      },
      analysisExport(tabName,msg,title){
        this.$emit('analysisExport',tabName,msg,title)
      },
      analysisCollect(msg){
        this.$emit('analysisCollect',msg)
      },
      closeLayerManageDialog(){
        this.$emit('closeLayerManageDialog')
      }
    },
  }
  </script>
  
  <style lang="less" scoped>
  /**infoview浮动面板*/
  .tdfxhzClass2{
    position: absolute;
    top: 40px;
    width: 40px;
    right: 0px;
    // padding: 0px 15px;
    border-radius: 4px;
    border: 1px solid rgba(128, 128, 128, 0.5);
    color: #ffffff;
    background: rgba(43, 73, 114, 1);
    box-shadow: 0 3px 14px rgba(128, 128, 128, 0.5);
    .headerClass{
        width: 100%;
        height: 40px;
        background-color: #2b4972;
        opacity: 0.8;
        line-height: 40px;
        display: flex;
        justify-content: center;
    }  
  }
  .tdfxhzClass {
    z-index: 100;
    position: absolute;
    top: 50px;
    right: 10px;
    width: 500px;
    max-width: 500px;
    height: 745px;
    border-radius: 4px;
    color: #ffffff;
    box-shadow: 0 3px 14px rgba(128, 128, 128, 0.5);
    backdrop-filter: blur(8px);
    padding: 0;
    .headerClass{
      position: relative;
      padding: 10px 8px 0;
    }
    .content {
      padding: 0 8px;
    }
    .selectTc{
        display: flex;
        color: #fff;
        align-items: center;  
        /deep/ .ant-col {
          display: flex;
        }
    }
    .selectFw{
        color: #fff;
    }
    .selectKjsf{
      color: #fff;
      height: 38px;
      padding-top: 10px;
      display: flex;
      align-items: center;
      /deep/ .ant-col {
        display: flex;
      }
    }
    .kjsfClass{
        width: 100%;
        margin-top: 8px;
        padding-left: 10px;
    }
    .treeSelect{
      width: 98% !important;
      margin-top: 5px;
    }
    .editInfo{
        width: 100%;
        margin-top: 10px;
        background-color: rgba(255,255,255,0.2);
        color: #fff;
        padding: 5px;
        display: flex;  
        justify-content: space-between;   
        align-items: center;
    }
    .staticInfo{
      width: 100%;
      .primaryBtn {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: auto;
        margin-top: 10px;
      }
      .tableInfo{
        width: 100%;
        height: 100%;
        margin-top: 10px;
      }
    }
    .statisticsBtn {
      width: 160px;
      position: absolute;
      left: 50%;
      transform: translatex(-50%);
      bottom: 10px;
      border: 0;
      color: rgba(255,255,255,0.6);
    }
    .fwToolClass{
        width: 100%;
    }
  }
  .infoview-left {
    right: auto;
    left: 10px;
  }
  /deep/ .ant-table-placeholder{
    padding: 40px 16px !important;
  }
  .tdfxhzClass input,
  .tdfxhzClass select,
  .tdfxhzClass textarea {
    color: #ffffff;
    background-color: rgba(32, 160, 255, 0.2);
    border: 1px solid #e4eaec;
    font-size: 14px;
  }
  </style>